"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var PERCENT_REGEXP = /^([-+]?[0-9]+)([,.][0-9]+)?$/;
exports.percentValidator = {
    name: 'percent',
    validation: function (value) {
        var valueWithoutWhitespace = utils_1.isDefined(value) ? String(value).replace(utils_1.WHITESPACE_PATTERN, '') : value;
        return utils_1.isEmpty(valueWithoutWhitespace) || PERCENT_REGEXP.test(valueWithoutWhitespace);
    },
};
//# sourceMappingURL=PercentValidator.js.map